import { defineNuxtPlugin } from '#app'
import type { KarteEventMap } from '~/types/karte-events'

const maxRetries = 20
const retryInterval = 500

export default defineNuxtPlugin(() => {
  let sendEvent:
    | (<E extends keyof KarteEventMap>(
        event: E,
        ...args: [KarteEventMap[E]] extends [never]
          ? [] // never なら引数なし
          : [data: KarteEventMap[E]] // それ以外は必須
      ) => Promise<void>)
    | undefined = undefined

  if (useRuntimeConfig().public.karteDebug) {
    sendEvent = async (event, ...args) => {
      const data = args[0]
      console.debug('[KARTE plugin] DEBUG: send', event, data)
      return Promise.resolve()
    }
  } else {
    sendEvent = async (event, ...args) => {
      let retries = 0

      const tryKarteEvent = () => {
        const krt = (window as any).krt
        if (typeof krt === 'function') {
          try {
            const data = args[0]
            krt('send', event, data)
            return true
          } catch (e) {
            console.error('[KARTE plugin] krt() execution failed:', e)
            return false
          }
        }
        return false
      }

      // 最初の試行
      if (tryKarteEvent()) return

      // リトライループ
      while (retries < maxRetries) {
        await sleep(retryInterval)
        retries++

        if (tryKarteEvent()) {
          return
        }
      }

      console.error(
        `[KARTE plugin] krt() is not defined after ${(retryInterval * maxRetries) / 1000} seconds of retrying`,
      )
    }
  }

  const identify = async () => {
    const { accountInfo } = useAuth()
    if (accountInfo.value) {
      // companyTypeに応じてnameを生成
      const name =
        accountInfo.value.companyType === 1
          ? `運営_企業側_${accountInfo.value.employeeName}`
          : `企業メンバー_${accountInfo.value.employeeCode}`

      await sendEvent('identify', {
        user_id: accountInfo.value?.employeeCode,
        email: accountInfo.value?.employeeEmail,
        name,
      })
    }
  }

  return {
    provide: {
      karte: { sendEvent, identify },
    },
  }
})
